/** --------------------------------------------------
*
*   components
*   PROFESSIONAL PROMPT
*
*  -------------------------------------------------- */

(function ($, Drupal, duo) {
  Drupal.behaviors.professional_prompt = {

    attach: function (context, settings) {
      const self = this;

      // only do the following once:
      $(document, context).once('professional_prompt').each(function() {
        self.init(context, settings);
      });
    },

    init: function(context, settings) {

      // get the 'professional prompt':
      const banner =  $('.js-prompt-professional');

      // check sessionStorage to see if we can display the banner:
      if (!window.sessionStorage.getItem('hide-ctaprofessionalglobal')) {
        banner.removeAttr('hidden');
      }

      // hide banner event:
      $('.js-close-block-ctaprofessionalglobal').click(function(){
        window.sessionStorage.setItem('hide-ctaprofessionalglobal', true);
        banner.attr('hidden', 'true');
      });
    }
  };
})(jQuery, Drupal, window.duo = window.duo || {});
